import { useMutation, useQueryClient } from 'react-query';

import type { TVendorCodesInternet } from './../../../models/vendor/VendorCodeModels';
import type { TCreateModel } from '../../../utils/hookUtils';
import QUERYKEYS from '../../../constants/queryKeys';
import { createVendorCodeInternet } from './../../../services/VendorCodesService';

const useCreateVendorCodeInternet = (): TCreateModel<TVendorCodesInternet> => {
  const queryClient = useQueryClient();
  const { isLoading, mutate } = useMutation(createVendorCodeInternet, {
    onSuccess: () =>
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey === QUERYKEYS.VENDOR_CODES || query.queryKey[0] === QUERYKEYS.VENDORS,
      }),
  });

  return {
    create: mutate,
    isLoading,
  };
};

export default useCreateVendorCodeInternet;
